export default () => {
  // return 'http://cloud-lbb-staging.junomax.co'
  return 'https://cloud-mlm.appbaystudio.com'
}